import {useEffect} from "react";
import SocialButtons from "../social-buttons/SocialButtons";
import { useLang } from "../../helpers/language";
import "./cup-modal.scss";
import {withDictionary, withLanguage} from "../../assets/js/contexts";
import parse from "html-react-parser";
const CupModal = ({
    cups,
    cup,
    activeIndex = 0,
    toggleCup,
    config,
    dictionary
}) => {
    const prev = () => {
        if (activeIndex === 0) {
            return toggleCup(cups.length - 1);
        }
        toggleCup(activeIndex - 1);
    };
  const { lang } = useLang();

    const next = () => {
        if (activeIndex === cups.length - 1) {
            return toggleCup(0);
        }

        toggleCup(activeIndex + 1);
    };

    useEffect(() => {
        document.getElementsByTagName("body")[0].classList.toggle("no-scroll");

        return() => {
            document.getElementsByTagName("body")[0].classList.toggle("no-scroll");
        };
    }, []);

    return (
        <div id="cup-modal">
            <div className="background"
                onClick={
                    () => {
                        toggleCup(null);
                    }
            }></div>
        <div className="container">
            <button onClick={prev} aria-label="prev">
                <img src="/static/icons/arrow-white.svg" data-arrow="left" alt=""/>
            </button>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="modal">
                        <div className="row align-items-center">
                            <div className="col-md-9 left">
                                <h1> {
                                    cups ? cups[activeIndex] ? cups[activeIndex]?.name ? cups[activeIndex]?.name[lang] ? cups[activeIndex]?.name[lang] : "" : "" : "" : ""
                                } </h1>
                                <p className="details">
                                    {
                                    `ALC ${
                                        cups[activeIndex].alc
                                    }% / IBU ${
                                        cups[activeIndex].ibu
                                    }`
                                }</p>
                                {
                                parse(cups ? cups[activeIndex] ? cups[activeIndex]?.desc ? cups[activeIndex]?.desc[lang] ? cups[activeIndex]?.desc[lang] : "" : "" : "" : "")
                            }
                                <SocialButtons/>
                            </div>
                            <div className="col-md-3 right">
                                <button onClick={
                                    () => toggleCup(null)
                                } aria-label="toggle cup"/>
                                <img src={
                                        cups[activeIndex]?.uploads ? `${
                                            config.api.API_URL
                                        }/${
                                            cups[activeIndex]?.uploads[0]?.path
                                        }` : null
                                    }
                                    width="100%"
                                    alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button onClick={next} aria-label="next">
                <img src="/static/icons/arrow-white.svg" data-arrow="right" alt=""/>
            </button>
        </div>
    </div>
    );
};

export default CupModal;
